export enum StoredDocumentSortings {
  NameAscending = "NameAscending",
  NameDescending = "NameDescending",
  UploadDateAscending = "UploadDateAscending",
  UploadDateDescending = "UploadDateDescending",
  CategoryNameAscending = "CategoryNameAscending",
  CategoryNameDescending = "CategoryNameDescending",
}
